export const vehicleTypesOptions = [
  { label: "Sedan", value: "Sedan" },
  { label: "Hatchback", value: "Hatchback" },
  { label: "SUV (Sport Utility Vehicle)", value: "SUV (Sport Utility Vehicle)" },
  { label: "Crossover (CUV)", value: "Crossover (CUV)" },
  { label: "Coupe", value: "Coupe" },
  { label: "Convertible", value: "Convertible" },
  { label: "Station Wagon", value: "Station Wagon" },
  { label: "Sports Car", value: "Sports Car" },
  { label: "Luxury Car", value: "Luxury Car" },
  { label: "Electric Car (EV)", value: "Electric Car (EV)" },
  { label: "Hybrid Car", value: "Hybrid Car" },
  { label: "Microcar / Compact Car", value: "Microcar / Compact Car" },
  { label: "Grand Tourer (GT)", value: "Grand Tourer (GT)" },
  { label: "Supercar", value: "Supercar" },
  { label: "Hypercar", value: "Hypercar" },
];

export type VehicleType = (typeof vehicleTypesOptions)[number]["value"];
